/* jshint esversion: 6 */
/* jshint ignore:start */
import { useContext, useEffect, useRef, useState } from 'react';
import { RiMapPin2Line, RiMapPinLine, RiSearchLine } from "react-icons/ri";
import { IoNotificationsOutline, IoHeart } from "react-icons/io5";
import { LuUser } from "react-icons/lu";
import { FiMail, FiPhone } from "react-icons/fi";
import { MyContext } from '../Context/MyProvider';
import Login from './Login';
import Signup from './Signup';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaStar } from "react-icons/fa";
import axios from 'axios';
import { HiOutlineMenuAlt1 } from "react-icons/hi";
import SaidMenu from './Profile/SaidMenu';
import { useTranslation } from 'react-i18next';
import PhoneInput, { formatPhoneNumberIntl } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { IoMdEye, IoMdEyeOff } from "react-icons/io";
import { showToast } from '../showTost';
import Logo from "../assets/Image/Logo.png";
import Loading from './Loading';
import secureLocalStorage from "react-secure-storage";
import { buildImageUrl } from '../utils/image';
import { readStoredObject } from '../utils/storage';
const Header = () => {

  const { ApiBaseUrl, ImgBaseUrl, isLoginShow, showBox, setIsLoginShow, setSelectProduct, setshowBox, setIsLogin, isSignUpShow, setIsSignUpShow, isLogin, setIsFooter, MenuRef, showMenu, setShowMenu, setActivePage, isShow, setIsShow, siteLogo, setSiteLogo, siteTitle, supportEmail, supportPhone } = useContext(MyContext);

  const { t, i18n } = useTranslation();

  const [userImg, setUserImg] = useState("");
  const [isShowImg, setIsShowImg] = useState(false);
  const [searchData, setSearchData] = useState([]);
  const [input, setInput] = useState();
  const [searchShow, setSearchShow] = useState(false);
  const [selectlag, setSelectLag] = useState('en');
  const [passType, setPassType] = useState("password");
  const [value, setValue] = useState();
  const [profilePic, setProfilePic] = useState();
  const [prodileData, setProfileData] = useState({ name: "", email: "", password: "" });
  const [apiloading, setApiLoading] = useState(false);
  const [searchstorelist, setSearchStoreList] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  const [lastScrollTop, setLastScrollTop] = useState(0);

  const Language = [{ id: 'en', title: "English" }, { id: 'ar', title: "عربي" }, { id: 'hi', title: "Hindi" }, { id: 'sp', title: "Spanish" }, { id: 'fr', title: "French" }, { id: 'ge', title: "Germany" }, { id: 'in', title: "Indonesia" }, { id: 'sa', title: "South Africa" }, { id: 'tu', title: "Turkish" }, { id: 'po', title: "Portuguese" },];

  const Navigate = useNavigate();
  const location = useLocation();
  const isStorePage = location.pathname.includes('store-home');
  const isHomeHero = location.pathname === '/';

  const InputRef = useRef();
  const FileRef = useRef();
  const NoMoreDataRef = useRef(true);

  const Currency = secureLocalStorage.getItem("currency");
  const LoginData = readStoredObject("Loginuser");
  var { country_code, name, email, phone } = LoginData || {};

  useEffect(() => {
    const Loginuser = readStoredObject("Loginuser");
    if (Loginuser) {
      const { image } = Loginuser;
      setUserImg(image);
      setIsShowImg(true);
    } else {
      setUserImg("");
      setIsShowImg(false);
    }
  }, [isLogin]);

  useEffect(() => {
    if (!input) return;

    setSearchShow(true);
    setApiLoading(true);
    setPage(1);
    NoMoreDataRef.current = true;

    if (isStorePage) {
      HandleStoreSerch(input, 1);
    } else {
      setPage(1);
      HandleDoctorSearch(input, 1);
    }
  }, [input]);

  const HandleDoctorSearch = (inputText, currentPage) => {

    navigator.geolocation.getCurrentPosition(position => {

      const lat = String(position.coords.latitude);
      const long = String(position.coords.longitude);

      axios.post(`${ApiBaseUrl}/customer/search_doctor`, { text: inputText, lat: lat, lon: long, page: currentPage })
        .then((res) => {
          // console.log("search_doctor", res);
          if (res.data.ResponseCode === 200) {
            const newDoctors = res.data.doctor_list;
            if (newDoctors.length === 0) NoMoreDataRef.current = false;
            setSearchData(prev => currentPage === 1 ? newDoctors : [...prev, ...newDoctors]);
            setHasMore(true);
          }
          setApiLoading(false);
        })
        .catch((error) => {
          console.error(error);
        });
    });
  }

  const HandleStoreSerch = (input, page) => {
    const LocalData = sessionStorage.getItem("Docdetails");

    if (LocalData) {

      const { Docid } = JSON.parse(LocalData);
      const Userid = secureLocalStorage.getItem("Userid");

      axios.post(`${ApiBaseUrl}/customer/product_search`, { uid: Userid, search_field: input, doctor_id: Docid, page })
        .then((res) => {
          // console.log("product_search", res);
          const { ResponseCode, product_list } = res.data;
          if (ResponseCode === 200) {
            if (product_list.length === 0) NoMoreDataRef.current = false;
            setApiLoading(false);
            setSearchStoreList(product_list);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollTop > lastScrollTop) {
      if (scrollTop + clientHeight >= scrollHeight - 10 && hasMore && NoMoreDataRef.current) {
        setHasMore(false);
        setPage(prev => prev + 1);
      }
    }
    setLastScrollTop(scrollTop);
  };

  useEffect(() => {
    if (page === 1 || !NoMoreDataRef) return;

    HandleDoctorSearch(input, page);

  }, [page])

  useEffect(() => {
    setProfileData({ name: name, email: email, password: "" });
    setValue(country_code + phone);
  }, [LoginData]);

  useEffect(() => {
    const Loginuser = readStoredObject("Loginuser");
    if (Loginuser) {
      const { image } = Loginuser;
      if (image) {
        setProfilePic(ImgBaseUrl + image);
      }
    }
  }, []);

  useEffect(() => {
    const savedLogo = secureLocalStorage.getItem("site_logo");
    if (savedLogo) setSiteLogo(savedLogo);
  }, [setSiteLogo]);

  const brandLogo = siteLogo ? buildImageUrl(ImgBaseUrl, siteLogo, "default") : Logo;
  const brandTitle = siteTitle || "RapidMediK";
  const emergencyPhone = supportPhone || "";
  const emergencyEmail = supportEmail || "care@rapidmedik.in";
  const emergencyTelHref = emergencyPhone ? `tel:${String(emergencyPhone).replace(/\s+/g, "")}` : undefined;
  const emergencyMailHref = emergencyEmail ? `mailto:${emergencyEmail}` : undefined;

  const HandleNavigate = (index) => {
    if (index === 0) {
      setActivePage(0);
      Navigate("/");
      setIsFooter(false);
    } else {
      if (window.innerWidth > 1025) {
        setActivePage(1);
        Navigate("/dashbord/booking");
      } else {
        setActivePage(0);
        Navigate("/");
      }
    }
  };

  useEffect(() => {
    const lang = secureLocalStorage.getItem("I18");

    if (lang) {
      setSelectLag(lang);
    }
  }, []);

  const HandleNavigateDoc = (e, title, Id, departmentid) => {
    e.stopPropagation();

    sessionStorage.setItem("Docprofile", JSON.stringify({ id: Id, department_id: departmentid, title: title, path: "/", pagename: "Home" }));
    Navigate(`/doctor-profile/${Id}`);

    setSearchShow(false);
    setInput("");
  };

  const changeLanguage = (lang) => {
    setSelectLag(lang);
    i18n.changeLanguage(lang);
    secureLocalStorage.setItem("I18", lang);
    setIsShow(false);
  };

  const HandleEditProfile = () => {
    const Userid = secureLocalStorage.getItem("Userid");

    if (!profilePic) {
      showToast({ title: t("Upload Profile Photo"), id: "error" });
      return;
    }

    if (!prodileData.name || !prodileData.email || !value) {
      showToast({ title: t("Enter details"), id: "error" });
      return;
    }

    const formattedNumber = formatPhoneNumberIntl(value);
    const countryCode = formattedNumber.split(' ')[0];
    const numberWithoutCode = formattedNumber.replace(countryCode, '').trim();
    const cleanedNumber = numberWithoutCode.split(' ').join('');

    const formData = new FormData();

    formData.append("id", Userid);
    formData.append("image", profilePic);
    formData.append("name", prodileData.name);
    formData.append("email", prodileData.email);
    formData.append("password", prodileData.password ? prodileData.password : "");
    formData.append("ccode", countryCode);
    formData.append("phone", cleanedNumber);

    axios.post(`${ApiBaseUrl}/customer/edit_profile`, formData)
      .then((res) => {
        // console.log(res);
        if (res.data.ResponseCode === 200) {
          showToast({ title: res.data.message, id: "success" });
          secureLocalStorage.setItem("Loginuser", JSON.stringify(res.data.customer_detail));
          setshowBox("");
          setIsLogin("123");
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const HandleShowMenu = () => {
    MenuRef.current.classList.add('open');
    setShowMenu(true);
  };

  const HandleSelectStore = (id) => {
    setSelectProduct(id);
    setSearchShow(false);
    setInput("");
  }

  const renderSearchBox = (wrapperClass = "search-box relative") => (
    <div className={wrapperClass}>
      <RiSearchLine className='icon' />
      <input type="text" value={input} onChange={(e) => setInput(e.target.value)} className='text-[16px] w-full min-w-0' placeholder={isStorePage ? t("Search Hevan Medical Store Product") : t("Search Doctor")} />

      {(input && searchShow) &&
        <div onScroll={handleScroll} className="w-[100%] max-h-[500px] absolute bg-[#F6F7F8] px-[10px] py-[5px] top-[65px] rounded-[10px] scroll-container z-[888]">
          {false ? <Loading CustomeStyle="w-full h-[480px] rounded-[10px] bg-white flex items-center justify-center" />
            : <div className="">
              {isStorePage
                ? <div className="">
                  {searchstorelist.length >= 1
                    ? searchstorelist.map((item, index) => {
                      return <div key={index} onClick={() => HandleSelectStore(item.id)} className="bg-white py-[8px] px-[10px] rounded-[10px] overflow-hidden cursor-pointer mt-[5px]">
                        <div className="flex items-center gap-[10px]">
                          <img src={ImgBaseUrl + item.product_image} className='w-[70px] rounded-[10px] object-cover' alt="product_image" />
                          <div className="w-[80%]">
                            <h1 className='font-[500] whitespace-nowrap overflow-hidden overflow-ellipsis'>{item.product_name}</h1>
                            <div className="flex items-center gap-[10px]">
                              <h1 className='font-bold'>{Currency}{item.price_detail[0].price}</h1>
                              <span className='line-through'>{Currency}{item.price_detail[0].base_price}</span>
                              <div className="bg-yellow-500 px-[8px] rounded-[50px]">
                                <p className='font-[500] text-white text-[14px]'>{item.price_detail[0].discount}% {t("OFF")}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    })
                    : <div className="bg-white h-[480px] rounded-[10px] flex items-center justify-center py-[20px]'">
                      <div className="text-center">
                        <h1 className='font-[500] text-[18px]'>{t("No product yet!")}</h1>
                        <p className='text-gray-600'>{t("Currently you don't have any")} <br /> {t("product in you area!.")}</p>
                      </div>
                    </div>}
                </div>
                : <div className="">
                  {searchData.length >= 1
                    ? searchData.map((item, index) => {
                      return <div onClick={(e) => HandleNavigateDoc(e, item.name, item.id, "0")} key={index} className="bg-white py-[8px] px-[10px] rounded-[10px] cursor-pointer mt-[5px]">
                        <div className="flex items-center gap-[10px]">
                          <img src={ImgBaseUrl + item.logo} className='max-w-[70px] min-w-[70px] h-[70px] rounded-[10px] object-cover border-[1px]' alt="" />
                          <div className="leading-[20px] w-[100%] overflow-hidden">
                            <h1 className='font-[500] text-[17px] whitespace-nowrap overflow-hidden overflow-ellipsis'>{item.name}</h1>
                            <p className='whitespace-nowrap overflow-hidden overflow-ellipsis'>{item.title}</p>
                            <p className='whitespace-nowrap overflow-hidden overflow-ellipsis'>{item.subtitle}</p>
                          </div>
                        </div>
                        <div className="mt-[5px] flex items-center gap-[10px] justify-between">
                          {item.tot_favorite === 1 && (
                            <h1 className='flex items-center gap-[5px] text-[#0d9488]'>
                              <IoHeart className='text-[16px]' aria-hidden />
                              {t("1 Love this")}
                            </h1>
                          )}
                          <h1 className='flex items-center gap-[5px] text-gray-700'>
                            <RiMapPinLine className='text-[16px] shrink-0' aria-hidden />
                            {item.distance}
                          </h1>
                          <h1 className='flex items-center gap-[5px]'><FaStar className='text-orange-400' /> {item.avg_star} {t("Reviews")}</h1>
                        </div>
                      </div>
                    })
                    : <div className='bg-white h-[480px] rounded-[10px] flex items-center justify-center text-center py-[20px]'>
                      <div className="text-center">
                        <h1 className='font-[500] text-[18px]'>{t("No Doctor yet!")}</h1>
                        <p className='text-gray-600'>{t("Currently you don't have any")} <br /> {t("doctor in you area!.")}</p>
                      </div>
                    </div>}
                </div>}
            </div>}
        </div>
      }
    </div>
  );


  return (
    <div className={`site-header-shell left-0 right-0 sticky top-0 z-[999] ${isHomeHero ? 'site-header-shell--on-hero' : ''}`}>

      <div className="header">

        <div className="header-brand logo-box">
          <button type="button" className='menuicon' onClick={HandleShowMenu} aria-label={t("Menu")}>
            <HiOutlineMenuAlt1 className='text-[25px]' />
          </button>
          <img
            onClick={() => HandleNavigate(0)}
            src={brandLogo}
            onError={(e) => {
              e.currentTarget.onerror = null;
              e.currentTarget.src = Logo;
            }}
            className='w-[44px] h-[44px] sm:w-[48px] sm:h-[48px] object-contain cursor-pointer shrink-0'
            alt="RapidMediK"
          />
          <button type="button" className='header-brand-title max-_1205_:hidden' onClick={() => HandleNavigate(0)}>
            <h3>{brandTitle}</h3>
          </button>

          <div className="header-mobile-auth">
            {isShowImg
              ? <button type="button" onClick={() => HandleNavigate(1)} className='header-avatar-btn' aria-label={t("Profile")}>
                {userImg
                  ? <img src={ImgBaseUrl + userImg} className='w-[100%] h-[100%] object-cover' alt="" />
                  : <div className="bg-[#F3F4F6] w-[100%] h-[100%] flex items-center justify-center font-[500] text-[18px]">
                    <span className='-mt-[4px]'>{name?.split("")[0]}</span>
                  </div>}
              </button>
              : <button type="button" onClick={() => setIsLoginShow(true)} className="login-btn login-btn--header login-btn--icon-only" aria-label={t("Login")}>
                <LuUser aria-hidden />
              </button>}
          </div>
        </div>

        <div className="header-toolbar header-toolbar--desktop info-box">
          <div className="header-search">
            {renderSearchBox("search-box relative w-full min-w-0")}
          </div>

          <div className="header-actions">
            <button
              type="button"
              className="header-icon-btn header-icon-btn--map"
              title={t("Doctors Map")}
              aria-label={t("Doctors Map")}
              onClick={() => Navigate("/map")}
            >
              <RiMapPin2Line className="text-[20px]" aria-hidden />
            </button>

            {emergencyPhone && (
              <a
                href={emergencyTelHref}
                className="header-icon-btn"
                title={`${t("Emergency Line")}: ${emergencyPhone}`}
                aria-label={`${t("Emergency Line")}: ${emergencyPhone}`}
              >
                <FiPhone className="text-[20px]" aria-hidden />
              </a>
            )}

            {emergencyEmail && (
              <a
                href={emergencyMailHref}
                className="header-icon-btn max-_770_:hidden"
                title={`${t("Support Email")}: ${emergencyEmail}`}
                aria-label={`${t("Support Email")}: ${emergencyEmail}`}
              >
                <FiMail className="text-[20px]" aria-hidden />
              </a>
            )}

            {isShowImg
              ? <button type="button" onClick={() => HandleNavigate(1)} className='header-avatar-btn' aria-label={t("Profile")}>
                {userImg
                  ? <img src={ImgBaseUrl + userImg} className='w-[100%] h-[100%] object-cover' alt="" />
                  : <div className="bg-[#F3F4F6] w-[100%] h-[100%] flex items-center justify-center font-[500] text-[18px]">
                    <span className='-mt-[4px]'>{name?.split("")[0]}</span>
                  </div>}
              </button>
              : <button type="button" onClick={() => setIsLoginShow(true)} className="login-btn login-btn--header" aria-label={t("Login")}>
                <LuUser aria-hidden />
                <span className="login-btn-label">{t("Login")}</span>
              </button>}

            <button
              type="button"
              className="header-icon-btn max-_770_:hidden"
              title={t("Notifications")}
              aria-label={t("Notifications")}
              onClick={() => {
                const Userid = secureLocalStorage.getItem("Userid");
                if (!Userid) setIsLoginShow(true);
                else Navigate("/notifications");
              }}
            >
              <IoNotificationsOutline className="text-[22px]" aria-hidden />
            </button>
          </div>
        </div>

      </div>

      <div ref={MenuRef} className="menu scroll-container">
        <div className="menu-drawer-search px-[20px] pt-[55px] pb-[12px] border-b border-[#8080803b]">
          {renderSearchBox("search-box relative w-full")}
        </div>
        {secureLocalStorage.getItem("Userid")
          ? <SaidMenu index={1} />
          : <div className="px-[20px] py-[20px] space-y-3 border-t border-[#8080803b]">
            <button
              type="button"
              onClick={() => { MenuRef.current.classList.remove('open'); setShowMenu(false); Navigate("/map"); }}
              className="w-full flex items-center justify-center gap-2 border border-[#0d9488] text-[#0d9488] font-[500] py-[10px] rounded-[999px]"
            >
              <RiMapPin2Line className="text-[20px]" aria-hidden />
              {t("Doctors Map")}
            </button>
            {emergencyPhone && (
              <a
                href={emergencyTelHref}
                className="w-full flex items-center justify-center gap-2 border border-[#8080803b] text-rm-ink font-[500] py-[10px] rounded-[999px] no-underline"
                onClick={() => { MenuRef.current.classList.remove('open'); setShowMenu(false); }}
              >
                <FiPhone className="text-[18px]" aria-hidden />
                {emergencyPhone}
              </a>
            )}
            <button
              type="button"
              onClick={() => { MenuRef.current.classList.remove('open'); setShowMenu(false); setIsLoginShow(true); }}
              className="login-btn w-full justify-center"
            >
              <LuUser />
              <h4 className='font-[500]'>{t("Login")}</h4>
            </button>
          </div>}
      </div>

      {isLoginShow && <div onClick={() => setIsLoginShow(false)} className="flex bg-[#00000069] h-full justify-center w-full fixed items-center left-0 top-0 z-[1200]">
        <div onClick={(e) => e.stopPropagation()} className="model">
          <Login />
        </div>
      </div>}

      {isSignUpShow && <div onClick={() => setIsSignUpShow(false)} className="flex bg-[#00000069] h-full justify-center w-full fixed items-center left-0 top-0 z-[999]">
        <div onClick={(e) => e.stopPropagation()} className="model">
          <Signup />
        </div>
      </div>}

      {showMenu && <div onClick={() => { MenuRef.current.classList.remove('open'); setShowMenu(false) }} className="overlay bg-[#00000080]"></div>}

      {searchShow && <div onClick={() => { setSearchShow(false); setInput("") }} className="overlay"></div>}

      {isShow && <div onClick={() => setIsShow("")} className="flex bg-[#00000069] h-full justify-center w-full fixed items-center left-0 top-0 z-[999]">
        <div onClick={(e) => e.stopPropagation()} className="bottme-box ">
          {Language.map((item, index) => {
            return <div key={index} onClick={() => changeLanguage(item.id, index)} className=" cursor-pointer border-[1px] border-[#8080803b] py-[8px] px-[10px] rounded-[10px] mt-[10px]">
              <div className="flex items-center gap-[10px] justify-between">
                <h1 className='font-[500] text-[15px]'>{item.title}</h1>
                <div className="w-[30px] check-box">
                  <input id="radio1" className="peer hidden" type="radio" name="group1" />
                  <div className={`w-5 h-5 rounded-full flex items-center justify-center ${selectlag === item.id ? "box-activeborder" : "box-border"}`}>
                    <span className={`w-[10px] h-[10px] rounded-full duration-[0.3s] ${selectlag === item.id && "box-activebg"}`}></span>
                  </div>
                </div>
              </div>
            </div>
          })}
        </div>
      </div>}

      {showBox && <div onClick={() => setshowBox("")} className="flex bg-[#00000069] h-full justify-center w-full fixed items-end left-0 top-0 z-[999]">
        <div style={{ borderRadius: "10px 10px 0 0" }} onClick={(e) => e.stopPropagation()} className="bottme-box">
          <h1 className='font-[500] text-[17px]'>{t("Edit Profile")}</h1>

          <div className="px-[20px] mt-[10px]">
            <button onClick={() => FileRef.current.click()} className="border-[1px] w-[100%] border-dashed border-[#0d9488] h-[150px] rounded-[15px] cursor-pointer flex items-center justify-center overflow-hidden ">
              {profilePic
                ? <img src={profilePic} className='w-[40%] h-[90%] object-cover rounded-[10px]' alt="" />
                : <h1 className='text-[#0d9488] text-[25px]'>+</h1>
              }
            </button>

            <input
              ref={FileRef}
              onChange={(e) => setProfilePic(URL.createObjectURL(e.target.files[0]))}
              type="file"
              accept="image/*"
              className='hidden'
            />

            <input value={prodileData.name} onChange={(e) => setProfileData({ ...prodileData, name: e.target.value })} className='w-[100%] border-[2px] border-[#8080803b] outline-none mt-[10px] rounded-[10px] px-[10px] py-[8px] focus-within:border-[#0d9488]' type="text" placeholder={name} />
            <input value={prodileData.email} onChange={(e) => setProfileData({ ...prodileData, email: e.target.value })} className='w-[100%] border-[2px] border-[#8080803b] outline-none mt-[10px] rounded-[10px] px-[10px] py-[8px] focus-within:border-[#0d9488]' type="text" placeholder={email} />
            <div className="relative border-[2px] border-[#8080803b] outline-none mt-[10px] rounded-[10px] px-[10px] py-[8px] focus-within:border-[#0d9488]">
              <PhoneInput
                className="w-[100%]"
                ref={InputRef}
                international
                defaultCountry="IN"
                value={value}
                onChange={setValue}
                name="phone"
                style={{ outline: "none" }}
              />
              {!value && <h1 onClick={() => InputRef.current.focus()} className='absolute top-[8px] left-[60px] text-gray-500'>{phone}</h1>}
            </div>
            <div className="relative">
              <input value={prodileData.password} onChange={(e) => setProfileData({ ...prodileData, password: e.target.value })} className='w-[100%] border-[2px] border-[#8080803b] outline-none mt-[10px] rounded-[10px] px-[10px] py-[8px] focus-within:border-[#0d9488]' type={passType} placeholder='Enter Password (Optional)' />
              <div className="absolute top-[23px] right-[20px]">
                {passType === "password" ? <IoMdEyeOff onClick={() => setPassType("text")} className='text-gray-500 text-[20px] cursor-pointer' /> : <IoMdEye onClick={() => setPassType("password")} className='text-gray-500 text-[20px] cursor-pointer' />}
              </div>
            </div>
            <button onClick={HandleEditProfile} className="payment-btn mt-[15px]">{t("Update")}</button>
          </div>
        </div>
      </div>}

    </div>
  )
}

export default Header
/* jshint ignore:end */
